import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import React, { useEffect, useRef } from "react";
import FormTextField from "../../components/formFields/FormTextField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { LoadingPanel } from "../../components/layout/Loading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";

import { closed } from "../../components/drawer/drawerSlice";
import { STATUSARRAY } from "../../_contstants/common";
import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";
import { clearBusinessTypeDetail } from "./businessTypeSlice";
import {
  createBusinessType,
  getAllBusinessTypes,
  getBusinessTypeById,
  updateBusinessType,
} from "./services/businessType.services";

const CreateBusinessType: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const BusinessTypeDetail = useAppSelector(
    (state) => state.businessType.BusinessTypeDetail
  );
  const BusinessTypeGUID = useAppSelector((state) => state.drawer.data);
  const formLoading = useAppSelector((state) => state.businessType.formLoading);
  useEffect(() => {
    return () => {
      dispatch(clearBusinessTypeDetail());
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    if (BusinessTypeGUID) {
      dispatch(getBusinessTypeById(BusinessTypeGUID));
    }
  }, [BusinessTypeGUID]);

  const handleSubmit = async (values: any) => {
    try {
      if (!BusinessTypeGUID) {
        const insertPayload = {
          BusinessType: values.BusinessType,
          ISActive: values.ISActive === 1,
        };
        const response = await dispatch(createBusinessType(insertPayload));
        if (response?.payload?.Status === 201) {
          dispatch(closed());
          dispatch(clearBusinessTypeDetail());
          dispatch(getAllBusinessTypes());
        }
      } else {
        const editPayload = {
          BusinessDetailsGUID: BusinessTypeGUID,
          BusinessType: values.BusinessType,
          ISActive: values.ISActive === 1,
        };
        const response = await dispatch(updateBusinessType(editPayload));
        if (response?.payload?.Status === 201) {
          dispatch(closed());
          dispatch(clearBusinessTypeDetail());
          dispatch(getAllBusinessTypes());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  if (formLoading) return <LoadingPanel gridRef={gridRef} />;

  console.log("BusinessTypeDetail" , BusinessTypeDetail)
  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={BusinessTypeDetail}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
            gap={{ rows: 10 }}
            cols={[{ width: "100%" }]}
          >
            <GridLayoutItem className="drawer-header">
              <Typography.h4 className="m-0">
                {BusinessTypeGUID
                  ? "Update Business type"
                  : "Create Business type"}
              </Typography.h4>
              <Button
                type="button"
                fillMode={"flat"}
                themeColor={"dark"}
                style={{ marginRight: 4 }}
                onClick={() => dispatch(closed())}
              >
                <RxCross1 />
              </Button>
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="BusinessType"
                label="Business Type"
                placeholder="Business Type"
                component={FormTextField}
                validator={requiredValidator}
                astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                id={"ISActive"}
                name={"ISActive"}
                placeholder="Status"
                validator={requiredValidator}
                astrike={true}
                component={FormSelectionField}
                label={"Status"}
                options={STATUSARRAY?.map((status: any) => {
                  return {
                    value: status.value,
                    label: status.label,
                  };
                })}
              />
            </GridLayoutItem>
            <GridLayoutItem
              colSpan={3}
              style={{
                marginTop: 20,
                width: "100%",
              }}
            >
              <ButtonWithLoading
                label={BusinessTypeGUID ? "Update" : "Create"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || formLoading}
                loading={formLoading}
              />
              <Button
                type="button"
                fillMode={"outline"}
                themeColor={"primary"}
                style={{ marginLeft: 4 }}
                onClick={handleFormClose}
              >
                Cancel
              </Button>
            </GridLayoutItem>
          </GridLayout>
        </FormElement>
      )}
    />
  );
};

export default CreateBusinessType;
